import { useContext, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { SUCURSAL_ORIGEN } from 'Constants'
import { Form, Formik } from 'formik'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import Product from '../Product'

import { FORM_HOME } from './Fields'

const HomeContent = (props) => {
  const {
    data,
    setData,
    dataBefore,
    openCancel,
    cancel,
    handleclose,
    closeModal,
    setRender,
    render,
    orderInfo,
    permissions,
    onDataChange,
  } = props
  const [edit] = useContext(EditContext)
  const createDismissableSnackbar = useCustomSnackbar()

  const [tab, setTab] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null
  const { state: print, setOpen: openPrint, setClose: closePrint } = SetState()

  const clonar = async () => {
    setIsLoading(true)
    const empresa = empresaId
    await interfaces.salesOrders
      .clonar(data.infoMain.id, empresa)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleclose()
        setRender(!render)
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    setIsLoading(false)
    closeModal()
  }

  async function createFact() {
    setIsLoading(true)
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    await interfaces.salesOrders
      .createFactura(values)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleclose()
        setRender(!render)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    closeModal()
    setIsLoading(false)
  }

  async function createDebit() {
    setIsLoading(true)
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    await interfaces.salesOrders
      .debitNote(values)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleclose()
        setRender(!render)
        orderInfo(res.header.header.newId)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data, {
          variant: 'error',
        })
      })
    closeModal()
    setIsLoading(false)
  }

  async function createCredit() {
    setIsLoading(true)
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    await interfaces.salesOrders
      .creditNote(values)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleclose()
        setRender(!render)
        orderInfo(res.header.header.newId)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data, {
          variant: 'error',
        })
      })
    closeModal()
    setIsLoading(false)
  }

  async function printRemito(id) {
    setIsLoading(true)
    await interfaces.plantDespatch
      .confirmAndPrint(id)
      .then((res) => {
        printPDF(res)
        createDismissableSnackbar('Remito generado con éxito!', {
          variant: 'success',
        })
        setRender(!render)
      })
      .catch(() => {
        createDismissableSnackbar('Este remito no contiene nada!', {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const remito = async () => {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .remito(values)
      .then((res) => {
        createDismissableSnackbar('Remito creado con éxito. Aguarde un momento para imprimir!', {
          variant: 'success',
        })
        handleclose()
        printRemito(res.data.remito_id)
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    closePrint()
    closeModal()
    setIsLoading(false)
  }

  const presupuesto = async () => {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .presupuesto(values)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Presupuesto impreso con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    closePrint()
    setIsLoading(false)
  }

  const comprobante = async () => {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .comprobante(values)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Comprobante impreso con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    closePrint()
    setIsLoading(false)
  }

  const garantia = async () => {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .garantia(values)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Garantía impresa con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    closePrint()
    setIsLoading(false)
  }

  const handleChange = (name, value) => {
    setData({
      ...data,
      infoMain: {
        ...data.infoMain,
        [name]: value,
      },
    })
  }

  const classes = useStyles()

  const isButtonEnabled = () => {
    const { formato_venta, comprobante, saldos, nro_comprobante } = data.infoMain
    const { paymentOrder } = data

    const saldoCliente = Number(saldos.saldoCliente)
    const totalSaldo = saldos.total
    const montoRecibo = Number(saldos.montoRecibo)
    const paymentTotal = Number(paymentOrder?.total || 0)

    // Verificar si existe nro comprobante
    if (nro_comprobante !== '1-') return false

    // Verificar si  hay productos
    if (data.productList.length === 0) return false

    // Si es contrafactura
    if (formato_venta === '2') return saldoCliente >= 0

    // Si es cuenta cliente o nota de debito
    if (formato_venta === '1' || [2, 7, 20, 202, 207].includes(comprobante)) {
      return montoRecibo + saldoCliente >= totalSaldo
    }

    // Si es una nota de credito
    if ([3, 8, 21, 203, 208].includes(comprobante)) {
      return totalSaldo - paymentTotal === 0
    }

    return true
  }

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <div
              style={{
                position: 'absolute',
                backgroundColor: 'white',
                zIndex: 10,
                marginBottom: '10rem',
                width: '97%',
                top: '7rem',
                paddingTop: '1rem',
              }}
            >
              <InputsWithoutValidate
                fields={FORM_HOME(
                  data.infoMain,
                  handleChange,
                  edit,
                  dataBefore,
                  permissions,
                  data.productList,
                  data.ctaCliente.tipo_responsable,
                  data.ctaCliente.cuit,
                  data.ctaCliente?.comprobante
                )}
                spacing={2}
              />
            </div>

            <div style={{ height: '900px' }}>
              <Product
                data={data}
                handleChange={onDataChange}
                openCancel={openCancel}
                edit={edit}
                dataBefore={dataBefore}
                handleclose={handleclose}
                cancel={cancel}
                setRender={setRender}
                render={render}
                setData={setData}
                permissions={permissions}
              />
            </div>

            <div className={classes.buttonsHome}>
              <CustomButton
                buttonEnd
                color="secondary"
                style={{
                  marginLeft: '1.5rem',
                  textTransform: 'none',
                }}
                text="Nota de débito"
                onClick={() => createDebit()}
                disabled={data.comprobantes?.length > 0 && !permissions.allowEditMin ? false : true}
              />

              <CustomButton
                buttonEnd
                color="primary"
                style={{
                  marginLeft: '1.5rem',
                  textTransform: 'none',
                }}
                text="Devolución"
                onClick={() => createCredit()}
                disabled={data.comprobantes?.length > 0 && !permissions.allowEditMin ? false : true}
              />

              <CustomButton
                buttonEnd
                style={{
                  marginLeft: '1.5rem',
                }}
                color="#818181"
                text="Imprimir"
                disabled={
                  [2, 7, 20, 202, 207, 3, 8, 21, 203, 208].includes(data.infoMain.comprobante) &&
                  data.infoMain.estado === 1
                    ? true
                    : permissions.allowEditMin
                      ? true
                      : false
                }
                onClick={openPrint}
              />

              <CustomButton
                buttonEnd
                style={{
                  marginLeft: '1.5rem',
                }}
                text="Clonar"
                color="#818181"
                disabled={
                  data.comprobantes?.length > 0 &&
                  [1, 6, 11, 19, 43].includes(data.infoMain.comprobante) &&
                  !permissions.allowEditMin
                    ? false
                    : true
                }
                onClick={clonar}
              />

              <CustomButton
                buttonEnd
                style={{
                  marginLeft: '1.5rem',
                  backgroundColor: '3E984C',
                }}
                text="Comprobante"
                onClick={() => createFact()}
                disabled={!isButtonEnabled()}
              />
            </div>
          </>
        )
      default:
        break
    }
  }

  const fieldsPrint = () => {
    const PRINT_TYPE = [
      {
        label: 'Remito',
        value: 'Remito',
      },
      {
        label: 'Presupuesto',
        value: 'Presupuesto',
      },
      {
        label: 'Comprobante',
        value: 'Comprobante',
      },
      {
        label: 'Garantia',
        value: 'Garantia',
      },
    ]
    return [
      {
        label: 'Imprimir',
        name: 'print',
        options: PRINT_TYPE,
        optionLabel: `options["label"]`,
        optionValue: 'value',
        getOptionDisabled: (option) => {
          if (
            data.infoMain.estado === 3 &&
            [2, 7, 20, 202, 207, 3, 8, 21, 203, 208].includes(data.infoMain.comprobante) &&
            option.label !== 'Comprobante'
          ) {
            return true
          }
          if (data.comprobantes.length === 0 && option.label === 'Garantia') {
            return true
          }
          if (
            data.comprobantes.length === 0 &&
            data.infoMain.origen !== 'DOS' &&
            data.infoMain.nro_comprobante === '1-' &&
            option.label === 'Comprobante'
          ) {
            return true
          }
          if (
            (data.comprobantes.length === 0 || data.receipt.id) &&
            option.label === 'Presupuesto'
          ) {
            return true
          }
          return false
        },
        disabledOptions:
          data.comprobantes.length === 0
            ? ['Garantia']
            : data.comprobantes === [] && data.infoMain.origen === 'DOS'
              ? ['Comprobante']
              : data.comprobantes !== []
                ? ['Presupuesto']
                : [],
        sm: 12,
        xs: 12,
        class: 'autocomplete',
      },
    ]
  }

  return (
    <>
      <ContentWithOutSubTabs
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />

      {print.suspense && (
        <DialogComponent
          open={print.open}
          title="Imprimir"
          handleclose={closePrint}
          widthLarge="500px"
          maxHeight
          disableBackdropClick
          disableEscapeKeyDown
          children={
            <Formik
              onSubmit={(values) => {
                values.print === 'Remito'
                  ? remito()
                  : values.print === 'Presupuesto'
                    ? presupuesto()
                    : values.print === 'Comprobante'
                      ? comprobante()
                      : garantia()
              }}
              initialValues={{
                print: null,
              }}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({ setFieldValue, isSubmitting, values }) => (
                <Form>
                  <InputsWithValidate
                    fields={fieldsPrint(values)}
                    spacing={2}
                    setFieldValue={setFieldValue}
                    isSubmitting={isSubmitting}
                  />
                  <CancelConfirmButtons
                    onClickCancel={() => closePrint()}
                    onSubmit={() => {
                      if (values.print === 'Remito') {
                        remito()
                      } else {
                        createDismissableSnackbar('Seleccione una opción válida para imprimir.', {
                          variant: 'warning',
                        })
                      }
                    }}
                    isLoading={isLoading}
                    disabledSubmit={isLoading || !values.print}
                  />
                </Form>
              )}
            </Formik>
          }
        />
      )}
    </>
  )
}

export default HomeContent
